'use client';

import { Color, ColorSize } from '@bytel/product-wall';
import '@bytel/product-wall/style';
import { Box, BoxContent, Text, TextLevels } from '@bytel/trilogy-react';

import { HomepackProduct, HomepackProductOptions, StaticPackProduct } from '@app-types/home-pack';

interface ProductColorContainerProps {
    product: HomepackProduct;
    detail: HomepackProductOptions;
    selectedProduct?: StaticPackProduct;
    onSelectedProduct: (mainProduct: HomepackProduct, details: HomepackProductOptions) => void;
}

export function ProductColorContainer({
    product,
    detail,
    selectedProduct,
    onSelectedProduct,
}: Readonly<ProductColorContainerProps>) {
    const isActive =
        selectedProduct?.mainProduct?.id === product.id && selectedProduct?.details?.colorCode === detail.colorCode;

    return (
        <Box
            active={isActive}
            onClick={() => {
                if (product) {
                    onSelectedProduct(product, detail);
                }
            }}
            flat
        >
            <BoxContent className='is-flex is-flex-col is-centered has-text-centered is-aligned-center gap-medium'>
                <Color size={ColorSize.MEDIUM} color={detail.colorCode!} shadowless />
                <Text level={TextLevels.TWO} marginless>
                    {detail.colorName}
                </Text>
            </BoxContent>
        </Box>
    );
}
